import type { SocialPostPreviewCardMetadata } from '@wix/ai-scheduling-assistant-common-lib/entities';

export const YOUTUBE_TITLE_LIMIT = 100;
export const YOUTUBE_DESCRIPTION_LIMIT = 250;

export type YoutubeLook = 'youtube-video' | 'youtube-short';

export function youtubeLook(card: Pick<SocialPostPreviewCardMetadata, 'postType' | 'media'>): YoutubeLook | undefined {
  if (card.media.length !== 1 || card.media[0].kind !== 'video') {
    return undefined;
  }
  return card.postType === 'short' ? 'youtube-short' : 'youtube-video';
}
